import { render, staticRenderFns } from "./sonet-imgs-swiper.vue?vue&type=template&id=4142e1e0&scoped=true"
import script from "./sonet-imgs-swiper.vue?vue&type=script&lang=js"
export * from "./sonet-imgs-swiper.vue?vue&type=script&lang=js"
import style0 from "./sonet-imgs-swiper.vue?vue&type=style&index=0&id=4142e1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142e1e0",
  null
  
)

export default component.exports